var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarCLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.76404 12.7509C9.76394 9.88698 11.4652 7.298 14.0905 6.16693C16.7157 5.03586 19.7609 5.57992 21.8344 7.55051L21.826 7.55321V7.55321C22.1758 7.88588 22.3159 8.38372 22.1911 8.85057C22.0664 9.31742 21.6968 9.67842 21.2279 9.79134C20.759 9.90426 20.266 9.75098 19.9433 9.39191C18.1267 7.74422 15.3308 7.84815 13.641 9.62618C11.9513 11.4042 11.9837 14.2081 13.7142 15.9464C15.4447 17.6846 18.2423 17.7235 20.0202 16.034L20.0463 16.0621C20.2847 15.8366 20.6001 15.711 20.9279 15.7109C21.6589 15.7198 22.2443 16.3209 22.2356 17.0535C22.2387 17.5796 21.9354 18.0592 21.4594 18.2809C19.324 20.0439 16.3652 20.4138 13.863 19.2307C11.3608 18.0476 9.76432 15.5238 9.76404 12.7509Z",
    className: "Icon-fill-color"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarCLogo);
export default __webpack_public_path__ + "static/media/sidebar-c-logo.404d64ad87ae3d452dddbfcbd9fa17d9.svg";
export { ForwardRef as ReactComponent };